export default {
  install(Vue){
    Vue.prototype.holdPagination = function(query){
      if(window.sessionStorage.getItem('pageQuery')){
        Object.keys(query).forEach(key => {
          query[key] = JSON.parse(window.sessionStorage.getItem('pageQuery'))[key]
        });
        return query
      }
    };
    Vue.prototype.saveListQuery = function (query){
      window.sessionStorage.setItem('pageQuery',JSON.stringify(query))
    };
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/base/baseFun.js